import React, { FC, useEffect, useState } from 'react';

import { useHeader } from '@app/components/common/navigation/hooks/header-service';
import { Table } from '@app/components/common/table';
import { useGuide } from '@app/hooks/use-guide';

import { useColumns } from './columns';
import { EditEquipmentType } from './edit';

const EquipmentsTypesTable: FC = () => {
  useHeader('Типы оборудования', []);

  const [units, setUnits] = useState<EntityBase[]>([]);
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState<EntityBase>();
  const columns = useColumns({ onEdit: setCurrent });

  const fetchGuide = useGuide('equipment_type', undefined, setLoading);

  useEffect(() => {
    fetchGuide().then(setUnits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Table
        title="Типы оборудования"
        data={units}
        columns={columns}
        loading={loading}
      />
      <EditEquipmentType
        open={!!current}
        equipmentType={current}
        equipmentTypes={units}
        onClose={() => setCurrent(undefined)}
      />
    </>
  );
};

export default EquipmentsTypesTable;
